import alignedUnderFill from "./fill/aligned-under.svg";
import alignmentFill from "./fill/alignment.svg";
import allTimeFill from "./fill/all-time.svg";
import announcementFill from "./fill/announcement.svg";
import arrowDownFill from "./fill/arrow-down.svg";
import arrows1Refresh68Fill from "./fill/arrows-1_refresh-68.svg";
import attachmentFill from "./fill/attachment.svg";
import attentionFill from "./fill/attention.svg";
import automationFill from "./fill/automation.svg";
import badgeFill from "./fill/badge.svg";
import businessBooksFill from "./fill/business_books.svg";
import businessBulb61Fill from "./fill/business_bulb-61.svg";
import businessBusinessContact86Fill from "./fill/business_business-contact-86.svg";
import businessChartPie35Fill from "./fill/business_chart-pie-35.svg";
import businessCoinsFill from "./fill/business_coins.svg";
import businessFactoryFill from "./fill/business_factory.svg";
import businessHammerFill from "./fill/business_hammer.svg";
import businessHierarchy55Fill from "./fill/business_hierarchy-55.svg";
import businessMoneyCoinsFill from "./fill/business_money-coins.svg";
import businessStrategyFill from "./fill/business_strategy.svg";
import businessWallet90Fill from "./fill/business_wallet-90.svg";
import cascadingMetricAlignmentFill from "./fill/cascading-metric-alignment.svg";
import cascadingMetricFill from "./fill/cascading-metric.svg";
import checkWhiteFill from "./fill/check-white.svg";
import clothesShoeWomanFill from "./fill/clothes_shoe-woman.svg";
import clothesSlacks13Fill from "./fill/clothes_slacks-13.svg";
import clothesTieBowFill from "./fill/clothes_tie-bow.svg";
import colorStarOrangeStrokeFill from "./fill/color-star-orange-stroke.svg";
import commentFill from "./fill/comment.svg";
import commentsOutlineFill from "./fill/comments-outline.svg";
import commentsFill from "./fill/comments.svg";
import contributingMetricFill from "./fill/contributing-metric.svg";
import conversationFill from "./fill/conversation.svg";
import designBookBookmarkFill from "./fill/design_book-bookmark.svg";
import designCloneFill from "./fill/design_clone.svg";
import designCodeEditorFill from "./fill/design_code-editor.svg";
import designCodeFill from "./fill/design_code.svg";
import designCropFill from "./fill/design_crop.svg";
import designDesignFill from "./fill/design_design.svg";
import designMouse10Fill from "./fill/design_mouse-10.svg";
import designPaint38Fill from "./fill/design_paint-38.svg";
import designWand99Fill from "./fill/design_wand-99.svg";
import designWebDesignFill from "./fill/design_web-design.svg";
import designWindowCodeFill from "./fill/design_window-code.svg";
import designWindowDevFill from "./fill/design_window-dev.svg";
import designWindowParagraphFill from "./fill/design_window-paragraph.svg";
import educationAtomFill from "./fill/education_atom.svg";
import educationBoard51Fill from "./fill/education_board-51.svg";
import educationHatFill from "./fill/education_hat.svg";
import educationLanguageFill from "./fill/education_language.svg";
import emoticonsFistFill from "./fill/emoticons_fist.svg";
import emoticonsLikeFill from "./fill/emoticons_like.svg";
import emoticonsMonsterFill from "./fill/emoticons_monster.svg";
import emoticonsSunglasses48Fill from "./fill/emoticons_sunglasses-48.svg";
import emoticonsVirusFill from "./fill/emoticons_virus.svg";
import employeeFill from "./fill/employee.svg";
import eyeFill from "./fill/eye.svg";
import filesFolder19Fill from "./fill/files_folder-19.svg";
import foodCoffeeLongFill from "./fill/food_coffee-long.svg";
import foodMugFill from "./fill/food_mug.svg";
import furnitureBedSideFill from "./fill/furniture_bed-side.svg";
import ghTrashBinFill from "./fill/gh-trash-bin.svg";
import goalFill from "./fill/goal.svg";
import healthBrainFill from "./fill/health_brain.svg";
import healthWeedFill from "./fill/health_weed.svg";
import inactiveTaskFill from "./fill/inactive-task.svg";
import insightFill from "./fill/insight.svg";
import insightboardFill from "./fill/insightboard.svg";
import jiraBugFill from "./fill/jira-bug.svg";
import jiraEpicFill from "./fill/jira-epic.svg";
import jiraIssueFill from "./fill/jira-issue.svg";
import jiraStoryFill from "./fill/jira-story.svg";
import jiraSubTaskFill from "./fill/jira-sub-task.svg";
import jiraSubtaskFill from "./fill/jira-subtask.svg";
import jiraTaskFill from "./fill/jira-task.svg";
import jiraFill from "./fill/jira.svg";
import kpiFill from "./fill/kpi.svg";
import linksFill from "./fill/links.svg";
import listFill from "./fill/list.svg";
import locationCompass04Fill from "./fill/location_compass-04.svg";
import locationPositionMarkerFill from "./fill/location_position-marker.svg";
import media1Image02Fill from "./fill/media-1_image-02.svg";
import media1SportFill from "./fill/media-1_sport.svg";
import media1TouchFill from "./fill/media-1_touch.svg";
import media1Video67Fill from "./fill/media-1_video-67.svg";
import mentionFill from "./fill/mention.svg";
import metricFill from "./fill/metric.svg";
import minusFill from "./fill/minus.svg";
import modeLandscapeFill from "./fill/mode-landscape.svg";
import modePortraitFill from "./fill/mode-portrait.svg";
import moreFill from "./fill/more.svg";
import noReflectionsFill from "./fill/no-reflections.svg";
import objectsBearFill from "./fill/objects_bear.svg";
import objectsLeaf36Fill from "./fill/objects_leaf-36.svg";
import objectsPlanetFill from "./fill/objects_planet.svg";
import objectsSpaceshipFill from "./fill/objects_spaceship.svg";
import objectsSupport17Fill from "./fill/objects_support-17.svg";
import owlFill from "./fill/owl.svg";
import planCommercialFill from "./fill/plan-commercial.svg";
import planEnterpriseFill from "./fill/plan-enterprise.svg";
import planEssentialsFill from "./fill/plan-essentials.svg";
import planScaleFill from "./fill/plan-scale.svg";
import planUpgradeFill from "./fill/plan-upgrade.svg";
import plusFill from "./fill/plus.svg";
import privateFill from "./fill/private.svg";
import progressFill from "./fill/progress.svg";
import publicFill from "./fill/public.svg";
import relatedFill from "./fill/related.svg";
import restrictedLicenseFill from "./fill/restricted-license.svg";
import robotFill from "./fill/robot.svg";
import searchFill from "./fill/search.svg";
import selectUserFill from "./fill/select-user.svg";
import sessionFill from "./fill/session.svg";
import shoppingBox3d50Fill from "./fill/shopping_box-3d-50.svg";
import shoppingCreditCardFill from "./fill/shopping_credit-card.svg";
import standardLicenseFill from "./fill/standard-license.svg";
import taskGreenFill from "./fill/task-green.svg";
import taskFill from "./fill/task.svg";
import teamFill from "./fill/team.svg";
import techComputerMonitorFill from "./fill/tech_computer-monitor.svg";
import techMobileButtonFill from "./fill/tech_mobile-button.svg";
import transportationPlane18Fill from "./fill/transportation_plane-18.svg";
import travelHutFill from "./fill/travel_hut.svg";
import travelWorldFill from "./fill/travel_world.svg";
import ui1Analytics88Fill from "./fill/ui-1_analytics-88.svg";
import ui1CalendarCheck59Fill from "./fill/ui-1_calendar-check-59.svg";
import ui1Dashboard30Fill from "./fill/ui-1_dashboard-30.svg";
import ui1DatabaseFill from "./fill/ui-1_database.svg";
import ui1Home51Fill from "./fill/ui-1_home-51.svg";
import ui1SettingsGear64Fill from "./fill/ui-1_settings-gear-64.svg";
import ui2Cloud25Fill from "./fill/ui-2_cloud-25.svg";
import ui2Favourite28Fill from "./fill/ui-2_favourite-28.svg";
import ui2Favourite31Fill from "./fill/ui-2_favourite-31.svg";
import ui2LabFill from "./fill/ui-2_lab.svg";
import updateFill from "./fill/update.svg";
import upgradeFill from "./fill/upgrade.svg";
import uploadFill from "./fill/upload.svg";
import usersMultiple11Fill from "./fill/users_multiple-11.svg";
import usersMultiple19Fill from "./fill/users_multiple-19.svg";
import whiteboardFill from "./fill/whiteboard.svg";
import addFromMarketplaceOutline from "./outline/add-from-marketplace.svg";
import alignBottomOutline from "./outline/align-bottom.svg";
import alignCenterOutline from "./outline/align-center.svg";
import alignLeftOutline from "./outline/align-left.svg";
import alignMiddleOutline from "./outline/align-middle.svg";
import alignRightOutline from "./outline/align-right.svg";
import alignTopOutline from "./outline/align-top.svg";
import alignmentViewOutline from "./outline/alignment-view.svg";
import announcementsOutline from "./outline/announcements.svg";
import archiveOutline from "./outline/archive.svg";
import arrowBigOutline from "./outline/arrow-big.svg";
import arrowDownSmallOutline from "./outline/arrow-down-small.svg";
import arrowRightSmallOutline from "./outline/arrow-right-small.svg";
import arrowUpSmallOutline from "./outline/arrow-up-small.svg";
import arrowsInOutline from "./outline/arrows-in.svg";
import arrowsOutOutline from "./outline/arrows-out.svg";
import attachmentOutline from "./outline/attachment.svg";
import attentionOutline from "./outline/attention.svg";
import automationOutline from "./outline/automation.svg";
import awardOutline from "./outline/award.svg";
import backOutline from "./outline/back.svg";
import binocularOutline from "./outline/binocular.svg";
import bookOutline from "./outline/book.svg";
import brandingOutline from "./outline/branding.svg";
import calendarOutline from "./outline/calendar.svg";
import cautionOutline from "./outline/caution.svg";
import chartOutline from "./outline/chart.svg";
import chatOutline from "./outline/chat.svg";
import checkSmallOutline from "./outline/check-small.svg";
import checkOutline from "./outline/check.svg";
import chevronDownBigOutline from "./outline/chevron-down-big.svg";
import chevronDownSmallOutline from "./outline/chevron-down-small.svg";
import chevronLeftBigOutline from "./outline/chevron-left-big.svg";
import chevronLeftSmallOutline from "./outline/chevron-left-small.svg";
import chevronRightBigOutline from "./outline/chevron-right-big.svg";
import chevronRightSmallOutline from "./outline/chevron-right-small.svg";
import chevronUpBigOutline from "./outline/chevron-up-big.svg";
import chevronUpSmallOutline from "./outline/chevron-up-small.svg";
import circleOutline from "./outline/circle.svg";
import clockOutline from "./outline/clock.svg";
import closeBigOutline from "./outline/close-big.svg";
import closeMediumOutline from "./outline/close-medium.svg";
import closeMenuOutline from "./outline/close-menu.svg";
import colapseNavOutline from "./outline/colapse-nav.svg";
import commentOutline from "./outline/comment.svg";
import commentsOutline from "./outline/comments.svg";
import consultingOutline from "./outline/consulting.svg";
import createNewOutline from "./outline/create-new.svg";
import creditCardOutline from "./outline/credit-card.svg";
import customFieldOutline from "./outline/custom-field.svg";
import doneOutline from "./outline/done.svg";
import downloadOutline from "./outline/download.svg";
import dragDropOutline from "./outline/drag-drop.svg";
import editOutline from "./outline/edit.svg";
import emailOutline from "./outline/email.svg";
import exportExcelOutline from "./outline/export-excel.svg";
import exportOutline from "./outline/export.svg";
import externalLinkOutline from "./outline/external-link.svg";
import failedOutline from "./outline/failed.svg";
import favoriteOutline from "./outline/favorite.svg";
import filterOutline from "./outline/filter.svg";
import fitToScreenOutline from "./outline/fit-to-screen.svg";
import gifOutline from "./outline/gif.svg";
import gridViewOutline from "./outline/grid-view.svg";
import handOutline from "./outline/hand.svg";
import helpOutline from "./outline/help.svg";
import hiddenOutline from "./outline/hidden.svg";
import homeOutline from "./outline/home.svg";
import imageOutline from "./outline/image.svg";
import infoOutline from "./outline/info.svg";
import inlineOutline from "./outline/inline.svg";
import insightboardOutline from "./outline/insightboard.svg";
import installOutline from "./outline/install.svg";
import integrationsOutline from "./outline/integrations.svg";
import jiraOutline from "./outline/jira.svg";
import kanbanOutline from "./outline/kanban.svg";
import keyOutline from "./outline/key.svg";
import krOutline from "./outline/kr.svg";
import licenseOutline from "./outline/license.svg";
import linkOutline from "./outline/link.svg";
import listBulletOutline from "./outline/list-bullet.svg";
import listNumbersOutline from "./outline/list-numbers.svg";
import listViewOutline from "./outline/list-view.svg";
import liveDemoOutline from "./outline/live-demo.svg";
import makeCopyOutline from "./outline/make-copy.svg";
import manageOutline from "./outline/manage.svg";
import mapOutline from "./outline/map.svg";
import mentionsOutline from "./outline/mentions.svg";
import menuHorizontalOutline from "./outline/menu-horizontal.svg";
import menuVerticalOutline from "./outline/menu-vertical.svg";
import minusOutline from "./outline/minus.svg";
import moveToOutline from "./outline/move-to.svg";
import moveOutline from "./outline/move.svg";
import multiselectOutline from "./outline/multiselect.svg";
import newListOutline from "./outline/new-list.svg";
import newOkrOutline from "./outline/new-okr.svg";
import notRestrictedOutline from "./outline/not-restricted.svg";
import noteOutline from "./outline/note.svg";
import notificationsOutline from "./outline/notifications.svg";
import objectiveOutline from "./outline/objective.svg";
import openMenuOutline from "./outline/open-menu.svg";
import organizationOutline from "./outline/organization.svg";
import parentChildViewOutline from "./outline/parent-child-view.svg";
import parentViewOutline from "./outline/parent-view.svg";
import pauseOutline from "./outline/pause.svg";
import pdfOutline from "./outline/pdf.svg";
import performanceOutline from "./outline/performance.svg";
import pieOutline from "./outline/pie.svg";
import playOutline from "./outline/play.svg";
import plusOutline from "./outline/plus.svg";
import pointerOutline from "./outline/pointer.svg";
import processOutline from "./outline/process.svg";
import publicOutline from "./outline/public.svg";
import reactionOutline from "./outline/reaction.svg";
import recenterOutline from "./outline/recenter.svg";
import refreshOutline from "./outline/refresh.svg";
import restrictedOutline from "./outline/restricted.svg";
import scrollOutline from "./outline/scroll.svg";
import searchOutline from "./outline/search.svg";
import securityOutline from "./outline/security.svg";
import sendOutline from "./outline/send.svg";
import sessionsOutline from "./outline/sessions.svg";
import shareOutline from "./outline/share.svg";
import slackOutline from "./outline/slack.svg";
import sortOutline from "./outline/sort.svg";
import sqlOutline from "./outline/sql.svg";
import tBoldOutline from "./outline/t-bold.svg";
import tItalicOutline from "./outline/t-italic.svg";
import tStrikeOutline from "./outline/t-strike.svg";
import tUnderlinedOutline from "./outline/t-underlined.svg";
import tOutline from "./outline/t.svg";
import tableOutline from "./outline/table.svg";
import tagOutline from "./outline/tag.svg";
import targetOutline from "./outline/target.svg";
import taskOutline from "./outline/task.svg";
import trashBinOutline from "./outline/trash-bin.svg";
import unknownOutline from "./outline/unknown.svg";
import uploadOutline from "./outline/upload.svg";
import userOutline from "./outline/user.svg";
import usersGroupOutline from "./outline/users-group.svg";
import verificationOutline from "./outline/verification.svg";
import viewOnlyOutline from "./outline/view-only.svg";
import whteboardsOutline from "./outline/whteboards.svg";
import wizardOutline from "./outline/wizard.svg";
import workdayOutline from "./outline/workday.svg";
import automationsTwotone from "./twotone/automations.svg";

export const icons = [
  alignedUnderFill,
  alignmentFill,
  allTimeFill,
  announcementFill,
  arrowDownFill,
  arrows1Refresh68Fill,
  attachmentFill,
  attentionFill,
  automationFill,
  badgeFill,
  businessBooksFill,
  businessBulb61Fill,
  businessBusinessContact86Fill,
  businessChartPie35Fill,
  businessCoinsFill,
  businessFactoryFill,
  businessHammerFill,
  businessHierarchy55Fill,
  businessMoneyCoinsFill,
  businessStrategyFill,
  businessWallet90Fill,
  cascadingMetricAlignmentFill,
  cascadingMetricFill,
  checkWhiteFill,
  clothesShoeWomanFill,
  clothesSlacks13Fill,
  clothesTieBowFill,
  colorStarOrangeStrokeFill,
  commentFill,
  commentsOutlineFill,
  commentsFill,
  contributingMetricFill,
  conversationFill,
  designBookBookmarkFill,
  designCloneFill,
  designCodeEditorFill,
  designCodeFill,
  designCropFill,
  designDesignFill,
  designMouse10Fill,
  designPaint38Fill,
  designWand99Fill,
  designWebDesignFill,
  designWindowCodeFill,
  designWindowDevFill,
  designWindowParagraphFill,
  educationAtomFill,
  educationBoard51Fill,
  educationHatFill,
  educationLanguageFill,
  emoticonsFistFill,
  emoticonsLikeFill,
  emoticonsMonsterFill,
  emoticonsSunglasses48Fill,
  emoticonsVirusFill,
  employeeFill,
  eyeFill,
  filesFolder19Fill,
  foodCoffeeLongFill,
  foodMugFill,
  furnitureBedSideFill,
  ghTrashBinFill,
  goalFill,
  healthBrainFill,
  healthWeedFill,
  inactiveTaskFill,
  insightFill,
  insightboardFill,
  jiraBugFill,
  jiraEpicFill,
  jiraIssueFill,
  jiraStoryFill,
  jiraSubTaskFill,
  jiraSubtaskFill,
  jiraTaskFill,
  jiraFill,
  kpiFill,
  linksFill,
  listFill,
  locationCompass04Fill,
  locationPositionMarkerFill,
  media1Image02Fill,
  media1SportFill,
  media1TouchFill,
  media1Video67Fill,
  mentionFill,
  metricFill,
  minusFill,
  moreFill,
  noReflectionsFill,
  objectsBearFill,
  objectsLeaf36Fill,
  objectsPlanetFill,
  objectsSpaceshipFill,
  objectsSupport17Fill,
  owlFill,
  planCommercialFill,
  planEnterpriseFill,
  planEssentialsFill,
  planScaleFill,
  planUpgradeFill,
  plusFill,
  privateFill,
  progressFill,
  publicFill,
  relatedFill,
  restrictedLicenseFill,
  robotFill,
  searchFill,
  selectUserFill,
  sessionFill,
  shoppingBox3d50Fill,
  shoppingCreditCardFill,
  standardLicenseFill,
  taskGreenFill,
  taskFill,
  teamFill,
  techComputerMonitorFill,
  techMobileButtonFill,
  transportationPlane18Fill,
  travelHutFill,
  travelWorldFill,
  ui1Analytics88Fill,
  ui1CalendarCheck59Fill,
  ui1Dashboard30Fill,
  ui1DatabaseFill,
  ui1Home51Fill,
  ui1SettingsGear64Fill,
  ui2Cloud25Fill,
  ui2Favourite28Fill,
  ui2Favourite31Fill,
  ui2LabFill,
  updateFill,
  upgradeFill,
  uploadFill,
  usersMultiple11Fill,
  usersMultiple19Fill,
  whiteboardFill,
  addFromMarketplaceOutline,
  alignBottomOutline,
  alignCenterOutline,
  alignLeftOutline,
  alignMiddleOutline,
  alignRightOutline,
  alignTopOutline,
  alignmentViewOutline,
  announcementsOutline,
  archiveOutline,
  arrowBigOutline,
  arrowDownSmallOutline,
  arrowRightSmallOutline,
  arrowUpSmallOutline,
  arrowsInOutline,
  arrowsOutOutline,
  attachmentOutline,
  attentionOutline,
  automationOutline,
  awardOutline,
  backOutline,
  binocularOutline,
  bookOutline,
  brandingOutline,
  calendarOutline,
  cautionOutline,
  chartOutline,
  chatOutline,
  checkSmallOutline,
  checkOutline,
  chevronDownBigOutline,
  chevronDownSmallOutline,
  chevronLeftBigOutline,
  chevronLeftSmallOutline,
  chevronRightBigOutline,
  chevronRightSmallOutline,
  chevronUpBigOutline,
  chevronUpSmallOutline,
  circleOutline,
  clockOutline,
  closeBigOutline,
  closeMediumOutline,
  closeMenuOutline,
  colapseNavOutline,
  commentOutline,
  commentsOutline,
  consultingOutline,
  createNewOutline,
  creditCardOutline,
  customFieldOutline,
  doneOutline,
  downloadOutline,
  dragDropOutline,
  editOutline,
  emailOutline,
  exportExcelOutline,
  exportOutline,
  externalLinkOutline,
  failedOutline,
  favoriteOutline,
  filterOutline,
  fitToScreenOutline,
  gifOutline,
  gridViewOutline,
  handOutline,
  helpOutline,
  hiddenOutline,
  homeOutline,
  imageOutline,
  infoOutline,
  inlineOutline,
  insightboardOutline,
  installOutline,
  integrationsOutline,
  jiraOutline,
  kanbanOutline,
  keyOutline,
  krOutline,
  licenseOutline,
  linkOutline,
  listBulletOutline,
  listNumbersOutline,
  listViewOutline,
  liveDemoOutline,
  makeCopyOutline,
  manageOutline,
  mapOutline,
  mentionsOutline,
  menuHorizontalOutline,
  menuVerticalOutline,
  minusOutline,
  moveToOutline,
  moveOutline,
  multiselectOutline,
  newListOutline,
  newOkrOutline,
  notRestrictedOutline,
  noteOutline,
  notificationsOutline,
  objectiveOutline,
  openMenuOutline,
  organizationOutline,
  parentChildViewOutline,
  parentViewOutline,
  pauseOutline,
  pdfOutline,
  performanceOutline,
  pieOutline,
  playOutline,
  plusOutline,
  pointerOutline,
  processOutline,
  publicOutline,
  reactionOutline,
  recenterOutline,
  refreshOutline,
  restrictedOutline,
  scrollOutline,
  searchOutline,
  securityOutline,
  sendOutline,
  sessionsOutline,
  shareOutline,
  slackOutline,
  sortOutline,
  sqlOutline,
  tBoldOutline,
  tItalicOutline,
  tStrikeOutline,
  tUnderlinedOutline,
  tOutline,
  tableOutline,
  tagOutline,
  targetOutline,
  taskOutline,
  trashBinOutline,
  unknownOutline,
  uploadOutline,
  userOutline,
  usersGroupOutline,
  verificationOutline,
  viewOnlyOutline,
  whteboardsOutline,
  wizardOutline,
  workdayOutline,
  automationsTwotone,
  modePortraitFill,
  modeLandscapeFill,
];
